import React, { memo } from 'react';
import FileIcon from 'components/Shared/Common/FileIcon';

const NoThumb = () => <FileIcon fileExtension="default" isDisplayable />;

export default memo(NoThumb);
